export default function SkeletonCard() {
  return (
    <div className="bg-white rounded-xl shadow-sm overflow-hidden border border-gray-200 w-full animate-pulse">
      <div className="bg-gray-200 h-40 sm:h-44" />
      <div className="p-4">
        <div className="h-4 bg-gray-200 rounded w-3/4 mb-3" />
        <div className="flex items-center gap-3 mb-3">
          <div className="h-3 bg-gray-200 rounded w-12" />
          <div className="h-3 bg-gray-200 rounded w-14" />
          <div className="h-3 bg-gray-200 rounded w-16" />
        </div>
        <div className="h-8 bg-gray-100 rounded-lg mb-2" />
        <div className="flex gap-1">
          <div className="flex-1 h-8 bg-gray-100 rounded-lg" />
          <div className="flex-1 h-8 bg-gray-100 rounded-lg" />
          <div className="flex-1 h-8 bg-gray-100 rounded-lg" />
          <div className="flex-1 h-8 bg-gray-100 rounded-lg" />
          <div className="flex-1 h-8 bg-gray-100 rounded-lg" />
        </div>
      </div>
    </div>
  );
}
